import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e3fa3012"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper ml20 p20"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_image = _resolveComponent("el-image");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_button, {
    style: {
      "display": "block"
    },
    class: "mb20",
    type: "primary",
    icon: "ArrowLeft",
    circle: "",
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.back(-1))
  }), _createVNode(_component_el_image, {
    src: 'data:image/png;base64,' + $setup.data.base64Str,
    lazy: ""
  }, {
    error: _withCtx(() => [_createTextVNode(" 加载中... ")]),
    _: 1
  }, 8, ["src"])]);
}